import { useNavigate } from "react-router-dom";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Topbar({ title, subtitle, actions }) {
  const navigate = useNavigate();
  return (
    <header
      className="bg-white border-b border-zinc-200 px-4 sm:px-6 lg:px-8 py-4 sm:py-5 sticky top-14 lg:top-0 z-10"
      data-testid="topbar"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-6">
        <div className="min-w-0">
          <div className="label-tiny text-zinc-400 mb-1 hidden sm:block">Portail d'activité d'Ecocasse</div>
          <h1
            className="font-heading text-xl sm:text-2xl tracking-tight font-semibold text-zinc-900 truncate"
            data-testid="page-title"
          >
            {title}
          </h1>
          {subtitle && <p className="text-xs sm:text-sm text-zinc-500 mt-0.5 hidden sm:block">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2 shrink-0 flex-wrap">
          {actions}
          <Button
            onClick={() => navigate("/envoyer")}
            className="bg-zinc-900 hover:bg-zinc-800 text-white rounded-sm h-9 px-3 sm:px-4 gap-2 text-xs sm:text-sm"
            data-testid="topbar-send-button"
          >
            <PaperPlaneTilt size={16} weight="bold" />
            <span className="hidden sm:inline">Envoyer un PDF</span>
            <span className="sm:hidden">Envoyer</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
